import {
  Inject,
  Renderer2,
  Component,
  OnInit,
  ViewContainerRef,
  ChangeDetectorRef,
} from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { CookieService } from "ngx-cookie-service";
import { ToastrManager } from "ng6-toastr-notifications";
import { DataService } from "../../../data.service";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { SessionStorageService } from "angular-web-storage";

declare var $: any;

@Component({
  selector: "app-dashcontent",
  templateUrl: "./dashcontent.component.html",
  styleUrls: ["./dashcontent.component.scss"],
})
export class DashcontentComponent implements OnInit {

  currentUrl: string;
  username: any;
  totprof: any;
  total: any;
  monthpro: any;
  created: any;
  login: any;
  loan: any;
  plan: any[] = [];
  email: any;
  status: any;

  stat: any;
  dep: any[] = [];
  acc: any;
  earn: any;
  pwith: any;
  lastwith: any;
  totwith: any;
  totdep: any;
  lastdep: any;
  showUnpaid: boolean = false;
  comingFromDeposit: boolean = false;
  unpaid: any = {};
  special: any[] = [];

  cookieValue = this.session.get("sessionID");

  constructor(
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private server: DataService,
    private cookieService: CookieService,
    public toastr: ToastrManager,
    private chRef: ChangeDetectorRef,
    public session: SessionStorageService,
    private route: Router,
    private activate: ActivatedRoute,
    vcr: ViewContainerRef
  ) {
    this.route.events.subscribe((event: NavigationEnd) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        //get query param and asin to comingFromDeposit
        if (this.currentUrl.includes("deposit")) {
          this.comingFromDeposit = true;
        }
      }
    });
  }

ngOnInit() {

  $("meta[name=viewport]").attr(
    "content",
    "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
  );

  const depPayload = {
    val: this.cookieValue,
    key: "dep",
  };

  this.server.Api(depPayload).subscribe((res: any) => {
    if (res && res.code === 1) {
      this.plan = res.plan || [];
    }
  });

  const data = this.activate.snapshot.data;

  if (!data || !data.news || !data.news.dep) {
    console.log("Resolver data missing");
    return;
  }

  const depData = data.news.dep;

  // SAFE message extraction
  const messageArray = depData.message || [];
  const message = messageArray.length > 0 ? messageArray[0] : {};

  this.dep = data.news.types?.message || [];

  this.username = message["username"] || null;
  this.earn = message["earning"] || 0;
  this.acc = message["mainaccountbal"] || 0;
  this.status = message["status"] || null;
  this.loan = message["loan_bal"] || 0;
  this.created = message["date_created"] || null;
  this.login = message["last_login"] || null;
  this.stat = message["status"] || null;

  this.pwith = depData["pwith"] || 0;
  this.lastwith = depData["lastwith"] || 0;
  this.totwith = depData["totwith"] || 0;
  this.totdep = depData["totdep"] || 0;
  this.totprof = depData["totpro"] || 0;
  this.lastdep = depData["lastdep"] || 0;
  this.monthpro = depData["monthpro"] || 0;

  this.unpaid = depData["unpaid"] || { count: [] };
  if(this.unpaid.count && this.unpaid.count.length > 0){
     this.toastr.infoToastr("Copy address and mark payment", 'Pending payment found');
  }
  this.special = depData["special"] || [];
  this.total = depData["add"] || 0;
  this.email = message["email"] || null;
}

  redirectTo(uri: string) {
    this.route
      .navigateByUrl("/", { skipLocationChange: true })
      .then(() => this.route.navigate([uri]));
  }

  cashout(x: string) {

    const btn = document.getElementById(x);
    if (btn) {
      $(btn).attr("disabled", true);
    }

    const out = {
      depID: x,
      token: this.cookieValue,
      key: "cashout",
    };

    this.server.Api(out).subscribe((res: any) => {
      if (res) {
        this.toastr.successToastr("Security center", res.message);
        if (btn) {
          $(btn).remove();
        }
      }
    });
  }

  copy() {
    const input = document.querySelector("input[readonly]") as HTMLInputElement;
    if (input) {
      input.select();
      document.execCommand("copy");
      this.toastr.successToastr("Link copied");
    }
  }

  paid(id) {

    if (!this.unpaid?.count || this.unpaid.count.length === 0) {
      this.toastr.warningToastr("No pending payment found");
      return;
    }

    const confirmed = confirm("Are you sure you have made payment?");
    if (!confirmed) return;

    const firstPayment = this.unpaid.count[0];

    const out = {
      depID: id,
      token: this.cookieValue,
      key: "paid",
    };

    this.server.Api(out).subscribe((res: any) => {
      if (res) {
        this.toastr.infoToastr("Pending confirmation", res.message);

        // Remove locally to prevent UI crash
        this.comingFromDeposit = false;
        this.showUnpaid = false;
        this.unpaid.count = [];
        this.chRef.detectChanges();
      }
    });
  }

  goHome() {
    this.comingFromDeposit = false;
    this.showUnpaid = false;
    this.route.navigate(['/dashboard']);
  }

}
